import React from 'react';
import {Divider, Stack, Typography} from '@mui/material';
import SourcesSection from '../../features/products/reportEditorPage/leftPanel/components/SourcesSection';
import SourcesFileViewerContent from '../../features/products/reportEditorPage/leftPanel/components/SourcesFileViewerContent';
import OverlayReportView from './OverlayReportView';
import DocumentView from '../DocumentView';
import useSourcePackageBuilderStore from '../../stores/useSourcePackageBuilderStore';

const MAIN_PANEL_WIDTH = '80%';
const SEARCH_LIST_WIDTH = '38%';
const DOCUMENT_VIEW_WIDTH = '62%';

/**
 * Center pane content — switches on the builder's viewKind so Corpus, My Files, and
 * Reports all render in this single overlay window (no separate modal / browser tab).
 */
const CenterView = () => {
    const viewKind = useSourcePackageBuilderStore((s) => s.viewKind);
    const filePayload = useSourcePackageBuilderStore((s) => s.filePayload);
    const reportPayload = useSourcePackageBuilderStore((s) => s.reportPayload);
    const isOpen = useSourcePackageBuilderStore((s) => s.isOpen);

    if (viewKind === 'file' && filePayload?.fileId) {
        return (
            <SourcesFileViewerContent
                fileId={filePayload.fileId}
                canonicalFileId={filePayload.canonicalFileId}
                fileName={filePayload.fileName}
                fileType={filePayload.fileType}
                fileSource={filePayload.fileSource}
                sentenceHit={filePayload.sentenceHit}
                active={isOpen}
            />
        );
    }

    if (viewKind === 'report' && reportPayload?.reportId) {
        return (
            <OverlayReportView
                reportId={reportPayload.reportId}
                snippet={reportPayload.snippet}
                query={reportPayload.query}
                active={isOpen}
            />
        );
    }

    return <DocumentView/>;
};

/**
 * SearchDocumentsPanel - Main panel containing the search list and document viewer.
 * Used inside SourcePackageBuilder.
 *
 * Renders the federated search surface directly in `search` mode (its own instance)
 * rather than the shared reverse-portal outlet — the portal now hosts the "My files"
 * file-manager surface, so reusing it here would show My Files instead of the search
 * results / selected segment.
 */
const SearchDocumentsPanel = () => (
    <Stack sx={{overflow: 'hidden', bgcolor: 'background.paper', width: MAIN_PANEL_WIDTH, borderRadius: 2}}>
        <Stack px={2} py={1.5} justifyContent="space-between" alignItems="center" direction="row">
            <Typography id="source-package-builder-title" variant="h6">Search Documents</Typography>
        </Stack>

        <Divider/>

        <Stack direction="row" justifyContent="center" alignItems="stretch" flex={1} overflow="hidden">
            <Stack width={SEARCH_LIST_WIDTH} overflow="auto">
                <SourcesSection isActive mode="search"/>
            </Stack>

            <Divider orientation="vertical"/>

            <Stack direction="row" sx={{width: DOCUMENT_VIEW_WIDTH, bgcolor: 'background.paper', overflow: 'auto'}}>
                <CenterView/>
            </Stack>
        </Stack>
    </Stack>
);

export default React.memo(SearchDocumentsPanel);

